__turbopack_context__.v({
  "backdrop": "spinner-module-scss-module__pAcBzG__backdrop",
  "center": "spinner-module-scss-module__pAcBzG__center",
  "partialSpinner": "spinner-module-scss-module__pAcBzG__partialSpinner",
});
